import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { format, utcToZonedTime } from 'date-fns-tz';
import Tippy from '@tippyjs/react';
import { TbSearch } from 'react-icons/tb';
import { FiEdit2, FiPlus, FiX } from 'react-icons/fi';
import InputMask from 'react-input-mask';
import { findManagers, findPlayer, getLinkedIndicators } from 'services/profile.service';
import { LinkedIndicators_Indicadores, User } from 'types/user';
import { RiSearchLine } from 'react-icons/ri';
import { useAuth } from 'context/AuthContext';
// import { actionLog } from 'services/actionlog.service';
import { BiInfoCircle } from 'react-icons/bi';
import {
  deleteFeedbackEcoaByQuery,
  getPlayerInfo,
  getServerTime,
  getTaskById,
  getTaskByIdEcoa,
  sendNotificationTask,
  sendPreferenceNotification,
  submitTask,
  submitTaskEcoa,
  updateTask,
  updateTaskEcoa,
  verifyTask,
} from 'services/dashboard.service';
import { MdOutlineExpandMore, MdOutlineExpandLess } from 'react-icons/md';

import { toast } from 'react-toastify';
import Modal from '../Modal/Index';
import CustomSelect from 'components/custom-select';
import { ineligibleIdsArray } from 'services/utils';
import TextEditor from 'components/text-editor';
import { contarCaracteresDoHtml } from 'components/text-editor/contagem';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';
import { getPerformanceCategory } from 'utils/helpers';
import { PERIOD_END_MIN, PERIOD_START_MIN, isPeriodEndValid, isPeriodStartValid } from 'utils/delivery-period';

import './style.scss';
import { getNecs, getUors, getDemandantes } from 'services/realizacao.service';
import Button from 'components/ui/button';
import { NoticeModal } from 'components/ui/notice-modal';
import { SelectField } from 'components/form';
import { FOCO_VISIVEL } from 'utils/foco';
import { textoDaContagem } from 'utils/strings';
import { useBuscaAoDigitar } from 'hooks/useBuscaAoDigitar';
import ModalDeCadastro, { DesfechoDoCadastro, EtapaDoCadastro } from 'pages/MissaoDestaque/Create/ModalDeCadastro';
import { AvisoDeValidacao, CAMPO, Iniciais, Nota, ROTULO, RostoDaPessoa } from 'pages/MissaoDestaque/Create/componentes-do-cadastro';
import {
  ORDEM_DE_EXIBICAO,
  etapaAnterior,
  posicaoNaTela,
  primeiraEtapa,
  proximaEtapa,
  ultimaEtapa,
} from 'pages/MissaoDestaque/Create/ordem-das-etapas';
import { NotFound } from 'pages/NotFound';

const maskTemplate = 'F9999999';

// Indexados pela etapa lógica de sempre (`step` 0 = integrantes, 1 = informações, 2 = detalhes), a mesma da Realização
// Destaque. A coluna segue a ordem do design (`ORDEM_DE_EXIBICAO`): Informações, Detalhes e resultados, Integrantes.
const ETAPAS_DO_CADASTRO: EtapaDoCadastro[] = [
  { titulo: 'Integrantes da Ecoa', descricao: 'Quem atuou com você' },
  { titulo: 'Informações da ação', descricao: 'Nome, eixo e prazos' },
  { titulo: 'Detalhes e resultados', descricao: 'O que a ação gerou' },
];

const ETAPAS_NA_TELA = ORDEM_DE_EXIBICAO.map(etapa => ETAPAS_DO_CADASTRO[etapa]);

const TITULOS_DAS_ETAPAS = ['Quem atuou com você nesta ação?', 'Informações da Ação Ecoa', 'Detalhes e resultados'];

const BOTAO_DO_RESPONSAVEL = `flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-jj-field border border-brand-blue bg-brand-white text-brand-blue hover:bg-brand-blue hover:text-brand-yellow ${FOCO_VISIVEL}`;

const indicadores = [
  {
    nome: 'Autodesenvolvimento',
    cod: 'Autodesenvolvimento',
  },
  {
    nome: 'Bem-estar',
    cod: 'Bem-estar',
  },
  {
    nome: 'Sustentabilidade',
    cod: 'Sustentabilidade',
  },
  {
    nome: 'Cultura',
    cod: 'Cultura',
  },
];

/** Quantas pessoas a busca ao digitar achou, para o leitor de tela (AJ3-33, AJ3-34). Sem resultado, o aviso visível fala. */
function anuncioDosResultados(buscando: boolean, resultados: unknown[] | undefined): string {
  if (buscando || !resultados?.length) return '';
  return `${textoDaContagem(resultados.length, 'pessoa encontrada', 'pessoas encontradas')}. Escolha na lista abaixo do campo.`;
}

export default function AcaoCreate() {
  const navigate = useNavigate();
  const params = useParams();

  const { user, userInfo, refreshUser, currentCycle, cycles } = useAuth();
  const { helpData } = useHelp();

  const [intervalId, setIntervalId] = useState<any>(null);

  const searchRef = useRef<any>();
  const messageRef = useRef<any>();
  const titleRef = useRef<any>();
  const periodStartRef = useRef<any>();
  const periodEndRef = useRef<any>();

  const [isOpen, setIsOpen] = useState(true);
  const [editing, setEditing] = useState(true);

  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [target, setTarget] = useState<User[]>();
  const [openTargetAlert, setOpenTargetAlert] = useState(false);
  const { showModal } = useModal();
  const [showModalTutorial, setshowModalTutorial] = useState(false);

  const [necsList, setNecsList] = useState<any>([]);
  const [demandanteList, setDemandanteList] = useState<any>([]);
  const [needNec, setNeedNec] = useState<any>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isEmptyName, setIsEmptyName] = useState(false);
  const [isAlreadySelectedInList, setIsAlreadySelectedInList] = useState(false);
  const [showDemandante, setShowDemandante] = useState(false);
  const [necIsSearched, setNecIsSearched] = useState(false);
  const [demandanteValue, setDemandanteValue] = useState<any>([]);
  const [selectedNec, setSelectedNec] = useState<any>([]);

  const [teamDistribution, setTeamDistribution] = useState<any>({});

  const [periodStart, setPeriodStart] = useState<any>();
  const [periodEnd, setPeriodEnd] = useState<any>();
  const [nec, setNec] = useState<any>();

  const [title, setTitle] = useState<string>();
  const [titleLength, setTitleLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [resultMessage, setResultMessage] = useState<string>();
  const [resultLength, setResultLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [indicator, setIndicator] = useState<{ label: string; value: number | string } | undefined>();
  const [indicatorsList, setIndicatorsList] = useState<LinkedIndicators_Indicadores[] | undefined>();

  const [searchingCurrentUser, setSearchingCurrentUser] = useState(false);
  // AJ3-33/34: uma busca por campo. Com as duas em andamento, a que volta primeiro não desliga o "carregando" nem o
  // anúncio da outra.
  const [buscandoParticipantes, setBuscandoParticipantes] = useState(false);
  const [buscandoResponsavel, setBuscandoResponsavel] = useState(false);
  const [loading, setLoading] = useState(false);
  const editando = !!params.id && params.id !== 'cadastrar';
  // Na edição, o formulário só monta depois de `loadData`: os editores leem o texto gravado apenas ao montar.
  const [carregandoAcao, setCarregandoAcao] = useState(editando);
  const [falhaAoCarregarAcao, setFalhaAoCarregarAcao] = useState(false);
  // Ação cuja leitura o formulário espera; outra `:id` na mesma rota volta a esconder o formulário até a nova leitura.
  const acaoEmLeitura = useRef<string>();
  const [submitted, setSubmitted] = useState(false);

  const [step, setStep] = useState(primeiraEtapa());

  const [submitError, setSubmitError] = useState<string>();

  const [mask, setMask] = useState('');

  const [showModalAlert, setShowModalAlert] = useState<any>(false);

  const [currentTask, setCurrentTask] = useState<any>();
  const [maxMembersWithoutApproval, setMaxMembersWithoutApproval] = useState<number>(20);
  const [maxMembers, setMaxMembers] = useState<number | undefined>();

  const [initialManager, setInitialManager] = useState<any>();
  const [searchResultsManager, setSearchResultsManager] = useState<User[]>([]);

  const [minDate, setMinDate] = useState<string>();
  const [maxDate, setMaxDate] = useState<string>();

  const [hasOtherType, setHasOtherType] = useState(false);

  const modalRef = useRef<HTMLDivElement>(null);
  const lastFocusedElementRef = useRef<HTMLElement | null>(null);

  const [usersNotification, setUsersNotification] = useState<string[]>([]);
  const [usersNotificationPreference, setUsersNotificationPreference] = useState<string[]>([]);

  const minTitleLength = 0;
  const maxTitleLength = 150;

  const minMessageLength = 0;
  const maxMessageLength = 600;

  const minResultLength = 0;
  const maxResultLength = 600;

  const minMessageTarget = 1;
  const maxMessageTarget = 200;

  const maxMembersByProfile = useMemo(() => {
    let maxM = 0;

    if (
      !!userInfo?.ro?.match(/(3GUE|2GUT|2GCA|2GUA)/gi) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 30))
    ) {
      maxM = 30;
    } else if (
      !!userInfo?.ro?.match(/(2GUE|1GUT|1GUA|1GCA)/gi) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 50))
    ) {
      maxM = 50;
    } else if (
      !![3003, 4005, 4007].includes(userInfo?.cod_funcao || 0) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 100))
    ) {
      maxM = 100;
    } else if (!![3002].includes(userInfo?.cod_funcao || 0)) {
      maxM = 1000000;
    } else {
      if (typeof maxMembers === 'number') {
        maxM = maxMembers;
      } else {
        maxM = maxMembersWithoutApproval;
      }
    }

    return maxM;
  }, [maxMembers, maxMembersWithoutApproval, userInfo]);

  const teamApproval = () => {
    const obj = {
      showAlert: false,
      showPending: false,
      isApproved: false,
      blockAdd: false,
      expired: false,
      rejected: false,
      taskStep: cycles?.find(x => {
        if (!!currentTask?._id) {
          return currentTask.created >= x.date_start && currentTask.created <= x.date_finish;
        } else {
          const date = +new Date();
          return date >= x.date_start && date <= x.date_finish;
        }
      }),
    };

    if (!!cycles && !!userInfo) {
      if (params?.id && params.id === 'cadastrar' && Array.isArray(target) && target.length > maxMembersWithoutApproval) {
        obj.showAlert = true;
      } else if (params?.id && params.id !== 'cadastrar') {
        if (!!currentTask?._id) {
          if (obj.taskStep?.status === 'open') {
            if (Array.isArray(target) && target.length > maxMembersWithoutApproval) {
              obj.showAlert = true;
            }

            if (currentTask.participants_approval?.status === 'pending') {
              obj.showPending = true;
            }

            if (currentTask.participants_approval?.status === 'approved') {
              obj.isApproved = true;
            }

            if (currentTask.participants_approval?.status === 'rejected') {
              obj.rejected = true;
            }
          } else if (obj.taskStep?.status === 'evaluation') {
            if (currentTask.participants_approval?.status === 'pending') {
              // obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersWithoutApproval);
              obj.expired = true;
            } else if (currentTask.participants_approval?.status === 'approved') {
              obj.isApproved = true;
              // obj.blockAdd = !!(!maxMembers || (maxMembers && target?.length && target.length >= maxMembers));
            } else {
              // if (typeof maxMembers === 'number') {
              //   obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembers);
              // } else {
              //   obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersWithoutApproval);
              // }
            }

            obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersByProfile);

            if (currentTask.participants_approval?.status === 'rejected') {
              obj.rejected = true;
            }
          } else {
            obj.blockAdd = true;
          }
        } else {
          obj.blockAdd = true;
        }
      }
    } else {
      obj.blockAdd = true;
    }

    return obj;
  };

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  /** Na máscara da matrícula ("F12_____") os espaços vazios são "_": eles não contam como letras digitadas. */
  const semMascara = (valor: string) => valor.replace(/_/g, '');

  // AJ3-33, AJ3-35 a AJ3-37: a busca de participantes acontece enquanto se digita; o Enter e a lupa buscam na hora.
  async function buscarParticipantes(matricula: string, ehAtual: () => boolean) {
    setOpenTargetAlert(false);
    setIsAlreadySelectedInList(false);

    if (!matricula) {
      setSearchResults([]);
      setIsEmpty(false);
      setIsEmptyName(false);
      setBuscandoParticipantes(false);
      return;
    }

    if (target?.find(item => item._id === matricula)) {
      setIsAlreadySelectedInList(true);
      setBuscandoParticipantes(false);
      return;
    }

    try {
      setBuscandoParticipantes(true);

      const result = await findPlayer(matricula, true, true, true, true);
      if (!ehAtual()) return;

      const filteredResults = result.filter((item: any) => item._id !== user?._id);
      const isCurrentUser = result.filter((item: any) => item._id === user?._id);

      setSearchResults(filteredResults);
      setIsEmpty(filteredResults.length === 0 && matricula.startsWith('F') && matricula.length === 8);
      setIsEmptyName(filteredResults.length === 0 && isCurrentUser.length === 0);
      setBuscandoParticipantes(false);
    } catch (e) {
      if (ehAtual()) setBuscandoParticipantes(false);
    }
  }

  // AJ3-34 a AJ3-37: a mesma busca ao digitar para o responsável por apreciar a ação.
  async function buscarResponsavel(termo: string, ehAtual: () => boolean) {
    if (!termo) {
      setSearchResultsManager([]);
      setBuscandoResponsavel(false);
      return;
    }

    try {
      setBuscandoResponsavel(true);

      const result = await findManagers(termo, [0, 1, 2, 3, 4, 5], true, true);
      if (!ehAtual()) return;

      setSearchResultsManager(result.filter((item: any) => item._id !== user?._id));
      setBuscandoResponsavel(false);
    } catch (e) {
      if (ehAtual()) setBuscandoResponsavel(false);
    }
  }

  const buscaDeParticipantes = useBuscaAoDigitar(buscarParticipantes);
  const buscaDeResponsavel = useBuscaAoDigitar(buscarResponsavel);

  function handleSearch(e?: any) {
    e?.preventDefault();
    buscaDeParticipantes.buscarAgora();
  }

  function handleSearchManager(e?: any) {
    e?.preventDefault();
    buscaDeResponsavel.buscarAgora();
  }

  async function handleSubmit() {
    try {
      if (
        loading ||
        !message ||
        !resultMessage ||
        !userInfo ||
        !titleLength ||
        titleLength?.textLength < minTitleLength ||
        titleLength?.fullLength > maxTitleLength ||
        !messageLength ||
        messageLength?.textLength < minMessageLength ||
        messageLength?.fullLength > maxMessageLength
      )
        return;

      setLoading(true);

      let team: any = [];

      if (target) {
        team =
          target.map(item => {
            return {
              _id: item._id,
              cad_missao: item.extra?.cad_missao,
              cod_etapa: item.extra?.cod_etapa,
              funcao_localizacao: item.extra?.funcao_localizacao,
              message: item.message,
            };
          }) || [];
      }

      team = validateDistribution(team);

      // const managerOnTeam = await checkManagerOnTeam(
      //   params.id && params.id !== 'cadastrar' ? currentTask.owner : user?._id,
      //   team.map((x: { _id: any }) => x._id),
      // );

      if (params.id && params.id !== 'cadastrar') {
        const actualTask = { ...currentTask, ecoa: true };

        if (actualTask.status === 'rejeitado' && !!actualTask?.feedback?.length) {
          deleteFeedbackEcoaByQuery(`taskId:'${actualTask._id}'`);
        }

        team.forEach((obj: any) => {
          const currentTaskTeamUser = actualTask.team.find((x: { _id: any }) => x._id === obj._id);

          if (!!currentTaskTeamUser) {
            if (currentTaskTeamUser.cad_missao) {
              obj.cad_missao = currentTaskTeamUser.cad_missao;
            }

            if (currentTaskTeamUser.cod_etapa) {
              obj.cod_etapa = currentTaskTeamUser.cod_etapa;
            }

            if (currentTaskTeamUser.funcao_localizacao) {
              obj.funcao_localizacao = currentTaskTeamUser.funcao_localizacao;
            }
          }
        });

        // team.forEach((obj: any) => {
        //   const currentTaskTeamUser = currentTask.team.find((x: { _id: any }) => x._id === obj._id);

        //   if (!!currentTaskTeamUser?.requiresApproval) {
        //     obj.requiresApproval = currentTaskTeamUser.requiresApproval;

        //     if (typeof currentTaskTeamUser.approvedByManager !== 'undefined') {
        //       obj.approvedByManager = currentTaskTeamUser.approvedByManager;
        //     }
        //   } else {
        //     const managerOnTeamUser = managerOnTeam?.find(x => x.chave === obj._id);

        //     if (!!managerOnTeamUser && !!managerOnTeamUser.requiresApproval) {
        //       obj.requiresApproval = true;
        //     }
        //   }
        // });

        const taskStep = teamApproval().taskStep;
        const totalParticipantes = team?.length;
        const participants_approval: any = {
          total: totalParticipantes,
        };

        if (teamApproval().isApproved && maxMembers) {
          if (taskStep?.status === 'open') {
            if (totalParticipantes > maxMembers) {
              delete actualTask.maxPlayersNumber;

              if (totalParticipantes >= 21 && totalParticipantes <= 30) {
                // Autorização por RO 3GUE, 2GUT, 2GCA, 2GUA
                participants_approval.status = 'pending';
                participants_approval.type = 'ro';
                participants_approval.values = '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
              } else if (totalParticipantes >= 31 && totalParticipantes <= 50) {
                // Autorização por RO 2GUE, 1GUT, 1GUA ou 1GCA
                participants_approval.status = 'pending';
                participants_approval.type = 'ro';
                participants_approval.values = '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
              } else if (totalParticipantes >= 51 && totalParticipantes <= 100) {
                // Autorização por Diretor ou Gerente Geral UE
                participants_approval.status = 'pending';
                participants_approval.type = 'cod_funcao';
                participants_approval.values = '3003,4005,4007,3002';
              } else if (totalParticipantes > 100) {
                // Autorização por Vice-Presidente.
                participants_approval.status = 'pending';
                participants_approval.type = 'cod_funcao';
                participants_approval.values = '3002';
              }
            }
          } else {
            if (totalParticipantes > maxMembersByProfile) {
              setLoading(false);

              return toast.error(`Você não pode inserir mais de ${maxMembersByProfile} participantes nessa ação.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

            if (actualTask?.participants_approval?.status) {
              participants_approval.status = actualTask?.participants_approval?.status;
            }

            if (actualTask?.participants_approval?.type) {
              participants_approval.type = actualTask?.participants_approval?.type;
            }

            if (actualTask?.participants_approval?.values) {
              participants_approval.values = actualTask?.participants_approval?.values;
            }
          }
        } else {
          if (taskStep?.status === 'open') {
            delete actualTask.maxPlayersNumber;

            if (totalParticipantes <= maxMembersWithoutApproval) {
              participants_approval.status = 'autoApproved';
            } else if (totalParticipantes >= 21 && totalParticipantes <= 30) {
              // Autorização por RO 3GUE, 2GUT, 2GCA, 2GUA
              participants_approval.status = 'pending';
              participants_approval.type = 'ro';
              participants_approval.values = '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
            } else if (totalParticipantes >= 31 && totalParticipantes <= 50) {
              // Autorização por RO 2GUE, 1GUT, 1GUA ou 1GCA
              participants_approval.status = 'pending';
              participants_approval.type = 'ro';
              participants_approval.values = '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
            } else if (totalParticipantes >= 51 && totalParticipantes <= 100) {
              // Autorização por Diretor ou Gerente Geral UE
              participants_approval.status = 'pending';
              participants_approval.type = 'cod_funcao';
              participants_approval.values = '3003,4005,4007,3002';
            } else if (totalParticipantes > 100) {
              // Autorização por Vice-Presidente.
              participants_approval.status = 'pending';
              participants_approval.type = 'cod_funcao';
              participants_approval.values = '3002';
            }
          } else {
            if (totalParticipantes > maxMembersByProfile) {
              setLoading(false);

              return toast.error(`Você não pode inserir mais de ${maxMembersByProfile} participantes nessa ação.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

            participants_approval.status = 'autoApproved';
          }
        }

        await updateTaskEcoa({
          ...actualTask,
          team,
          title,
          indicator: {
            nome: indicator?.label || undefined,
            cod: indicator?.value || undefined,
          },
          start: { $date: new Date(periodStart).getTime() },
          end: { $date: new Date(periodEnd).getTime() },
          nec: selectedNec?.value,
          description: message,
          status: userInfo.ecoa !== 'INTEGRANTE' ? actualTask.status : 'aguardando',
          original_manager: initialManager._id,
          result: resultMessage,
          participants_approval,
        });
      } else {
        const serverTime = await getServerTime();

        if (
          !currentCycle?.status ||
          currentCycle.status !== 'open' ||
          serverTime > currentCycle.date_finish ||
          serverTime < currentCycle.date_start
        ) {
          return toast.error(`Não há fase disponível para envio de realizações.`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }

        const data = await submitTaskEcoa({
          owner: user?._id,
          owner_cad_missao: userInfo?.cad_missao,
          owner_cod_etapa: userInfo?.cod_etapa,
          owner_funcao_localizacao: userInfo?.funcao_localizacao,
          team,
          start: { $date: new Date(periodStart).getTime() },
          end: { $date: new Date(periodEnd).getTime() },
          nec: selectedNec.value,
          title,
          indicator: {
            nome: indicator?.label || undefined,
            cod: indicator?.value || undefined,
          },
          description: message,
          status: 'aguardando',
          original_manager: initialManager._id,
          result: resultMessage,
          ecoa: true,
        });

        if (!data._id && data?.message) {
          setSubmitError(data.message);
        }
      }

      setLoading(false);
      setSubmitted(true);
      refreshUser();
    } catch (e) {
      setLoading(false);
    }
  }

  function removerTagsP(texto: string): string {
    const regex = /<p[^>]*>|<\/p>|\n|&nbsp;/gi;
    const textoSemTagsP = texto.replace(regex, '');

    return textoSemTagsP;
  }

  function removeTarget(index: number) {
    if (target && target.length) {
      const newTargetList = [...target];
      newTargetList.splice(index, 1);
      setTarget(newTargetList);
    }
  }

  const extractKeys = (data: any) => {
    const keys = [];

    if (data) {
      keys.push(data.chave);

      Object.keys(data).forEach(key => {
        if (key.startsWith('gestor') && key !== 'gestor1') {
          keys.push(data[key].chave);
        }
      });
    }

    return keys;
  };

  function addTarget(item: User) {
    const isOnTarget = target?.find((e: User) => e._id === item._id);

    focusOnElement('.currentAction input');

    if (!!isOnTarget) {
      setShowModalAlert('Esse funcionário já está na lista de participante da ação.');
      return;
    }
    const isInvalided = userInfo?.gestores?.find((e: string) => e === item._id);

    const gestoresByOwner = extractKeys(currentTask?.gestores);

    const isInvalidedByOwner = gestoresByOwner.find((e: string) => e === item._id);

    const ineligible = ineligibleIdsArray.find(e => e === item?.extra?.cod_funcao);

    // if (!!isInvalided || !!isInvalidedByOwner) {
    //   setShowModalAlert('Esta pessoa não pode ser indicada nesta ação, pois ela faz parte do fluxo de apreciação desta entrega.');
    //   return;
    // }

    if (['TUTOR', 'COORDENADOR'].includes(item?.extra?.ecoa)) {
      setShowModalAlert('É vedada a inclusão de Coordenador e Tutor. Consulte a IN 403-1 item 7.4.6.4.4.2.5.');
      return;
    }

    // if (!!ineligible) {
    //   setShowModalAlert('Essa pessoa não pode ser indicada em Ações ECOA.');
    //   return;
    // }

    if (!item.canAddUser) {
      if (!usersNotification || !usersNotification.length || !usersNotification?.find((e: string) => e === item._id)) {
        const payload = {
          target: item._id,
          user: userInfo?.chave,
          fase: currentCycle?._id,
          created: { $date: new Date().getTime() },
        };

        sendNotificationTask(payload);
        setUsersNotification([...usersNotification, item._id]);
      }
      setShowModalAlert('Esse funcionário não pode ser adicionado a esta ação.');
      return;
    }

    if (item?.extra?.actions === false) {
      if (
        !usersNotificationPreference ||
        !usersNotificationPreference.length ||
        !usersNotificationPreference?.find((e: string) => e === item._id)
      ) {
        setUsersNotificationPreference([...usersNotificationPreference, item._id]);

        const payload = {
          target: item._id,
          user: userInfo?.chave,
          item: 'action',
          created: { $date: new Date().getTime() },
        };

        sendPreferenceNotification(payload);
      }
      setShowModalAlert(`${item?.extra?.nome_guerra} optou, em "Minhas Preferências", pela não participação nesta dinâmica.`);
      return;
    }

    const newTargetList = target || [];
    newTargetList.push(item);
    setTarget(newTargetList);
    setSearchResults([]);
    setBuscandoParticipantes(false);
    if (searchRef && searchRef.current) {
      searchRef.current.value = '';
    }
    buscaDeParticipantes.limpar();
    if (teamApproval().showAlert) {
      setOpenTargetAlert(true);
    }
  }

  function reset() {
    setTarget(undefined);
    setSubmitted(false);
    setLoading(false);
    setSubmitError(undefined);
    setSearchResults([]);
    setBuscandoParticipantes(false);
    setBuscandoResponsavel(false);
    setMessage(undefined);
    setResultMessage(undefined);
    setTitle(undefined);
    setPeriodStart(undefined);
    setPeriodEnd(undefined);
    setNec(undefined);
    setIndicator(undefined);
    setStep(primeiraEtapa());
    setTeamDistribution(undefined);
  }

  function handleCloseModal() {
    reset();
    navigate('../', { state: { direction: 'back' } });
    // lastFocusedElementRef.current?.focus();
    // document.removeEventListener('keydown', trapFocus);
  }

  const handleDemandanteChange = (e: any) => {
    if (selectedNec.value.cd_alcc === '123456789') {
      setDemandanteValue(e);
      selectedNec.value.nm_uor_sltt = e.value;
    }
  };

  function validateInput(e: any) {
    if (e.value > 100) {
      e.value = 100;
    } else if (e.value < 0) {
      e.value = 0;
    } else if (e.value === '') {
      e.value = 0;
    }

    const teamMember = e.id.replace('team_player_', '');

    setTeamDistribution({ ...teamDistribution, [teamMember]: e.value });
  }

  const isValidDistribution: boolean = useMemo((): boolean => {
    if (!target?.length || !Object.keys(teamDistribution).length) return false;

    for (let index = 0; index < target.length; index++) {
      const teamItem = teamDistribution[target[index]._id];

      if (!teamItem || isNaN(Number(teamItem)) || Number(teamItem) <= 0) {
        return false;
      }
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, teamDistribution, searchResults]);

  const isValidDistributionMessage: boolean = useMemo((): boolean => {
    if (!target?.length) return false;

    for (let index = 0; index < target.length; index++) {
      const teamItem = target[index];

      if (
        !teamItem.message ||
        !teamItem.messageLength ||
        teamItem.messageLength.textLength < minMessageTarget ||
        teamItem.messageLength.fullLength > maxMessageTarget
      ) {
        return false;
      }
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, searchResults]);

  function validateDistribution(team: any) {
    if (team) {
      let valid = true;
      const updatedTeam = [...team];
      const distribution = updatedTeam.map((item: any, index: number) => {
        try {
          const teamInput: any = teamDistribution[item._id] || 0;
          if (isNaN(teamInput) || teamInput > 100 || teamInput <= 0) {
            valid = false;
          }
          return { ...item, percent: parseInt(teamInput) };
        } catch (e) {
          console.log(e);
          valid = false;
          return { ...item };
        }
      });

      if (valid) {
        return distribution;
      } else {
        return team;
      }
    } else {
      return [];
    }
  }

  function getUserDistribution(_id: string) {
    try {
      return teamDistribution[_id];
    } catch (e) {
      return 0;
    }
  }

  function handleChangeTitle(content: string, contentLength: any) {
    setTitle(removerTagsP(content));
    setTitleLength(contentLength);
  }

  function handleChangeMessage(content: string, contentLength: any) {
    setMessage(removerTagsP(content));
    setMessageLength(contentLength);
  }

  function handleChangeResult(content: string, contentLength: any) {
    setResultMessage(removerTagsP(content));
    setResultLength(contentLength);
  }

  function handleChangeMessageTarget(content: string, contentLength: any, index: number) {
    const newTarget = target ? [...target] : [];
    newTarget[index].message = content;
    newTarget[index].messageLength = contentLength;
    setTarget(newTarget);
  }

  async function loadNecs(nec?: string) {
    const necs = await getNecs(nec);
    setNecsList(necs);

    return necs;
  }

  function getPositionLabel() {
    try {
      return (
        <div className="p-1 text-left text-white text-sm font-thin">
          <p>
            Caso não exista Necessidade de TI vinculada, escreva a sequência "123456789". Será obrigatório preencher o campo
            demandante.
          </p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  useEffect(() => {
    async function loadData() {
      const idDaLeitura = params.id;
      // ECN-35: se o `:id` mudou durante a leitura, a ação anterior não sobrescreve a nova.
      const leituraVencida = () => acaoEmLeitura.current !== idDaLeitura;

      try {
        await preencherComAcaoGravada(idDaLeitura, leituraVencida);
      } catch (e) {
        if (leituraVencida()) return;
        console.error(e);
        setFalhaAoCarregarAcao(true);
      } finally {
        if (!leituraVencida()) {
          setLoading(false);
          setCarregandoAcao(false);
        }
      }
    }

    async function preencherComAcaoGravada(idDaLeitura: string | undefined, leituraVencida: () => boolean) {
      const result = await getTaskByIdEcoa(idDaLeitura);
      if (leituraVencida()) return;
      if (!result || Array.isArray(result)) throw new Error(`Ação Ecoa ${idDaLeitura} não encontrada.`);

      if (userInfo) {
        setCurrentTask(result);
        setEditing(true);

        const resp = await getPlayerInfo('F' + result?.original_manager?.padStart(7, '0'));
        if (leituraVencida()) return;
        if (resp) {
          setInitialManager(resp);
        }

        if (!!result?.maxPlayersNumber) {
          setMaxMembers(result.maxPlayersNumber as number);
        }

        setIndicatorsList(indicadores);

        const isOwnerOnTeam: any = result.team.find((item: any) => item._id === user?._id);

        if (!isOwnerOnTeam && userInfo.ecoa === 'INTEGRANTE') {
          result.target.push({
            _id: user?._id,
            name: user?.name,
            extra: user?.extra,
          });
          result.team.push({
            _id: user?._id,
          });
        }

        const currentTeam = result.target.sort((a: any, b: any) => (a._id === user?._id ? -1 : 1)); // = result.target.filter((item:any)=>item._id !== user?._id);
        const currentDistribution = result.team.reduce((value: any, item: any) => {
          value[item._id] = item.percent;
          return value;
        }, {});

        currentTeam.map((item: any) => {
          item.message = result?.team?.find((x: any) => x._id === item._id)?.message;
          return item;
        });

        setTarget(currentTeam);
        setTeamDistribution(currentDistribution);
        setMessage(result.description);
        setMessageLength(contarCaracteresDoHtml(result.description));
        setResultMessage(result.result);
        setResultLength(contarCaracteresDoHtml(result.result));
        setTitle(result.title);
        setTitleLength(contarCaracteresDoHtml(result.title));
        setDemandanteValue(
          result.nec && result.nec.cd_alcc === '123456789'
            ? {
                label: result.nec.nm_uor_sltt,
                value: result.nec.nm_uor_sltt,
              }
            : result.nec && result.nec.cd_alcc !== '123456789'
              ? result.nec.nm_uor_sltt
              : undefined,
        );
        const selectNec = await defineSelectedNec(result);
        if (leituraVencida()) return;
        setSelectedNec(selectNec);
        setIndicator(
          result.indicator
            ? {
                label: result.indicator.nome,
                value: result.indicator.cod,
              }
            : undefined,
        );

        try {
          setPeriodStart(format(utcToZonedTime(result.start, 'GMT'), 'yyyy-MM-dd'));
          setPeriodEnd(format(utcToZonedTime(result.end, 'GMT'), 'yyyy-MM-dd'));
        } catch (e) {
          console.log(e);
        }

        const date = new Date(result.created);

        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        setMaxDate(format(lastDay, 'yyyy-MM-dd'));
        setMinDate(format(firstDay, 'yyyy-MM-dd'));
      }
    }

    async function loadUors() {
      const uors = await getUors(userInfo?.uor_trabalho);
      setNeedNec(uors);
    }

    async function loadDemandates() {
      const demandantes = await getDemandantes();
      setDemandanteList(demandantes);
    }

    async function loadUserBySearch() {
      // const listLinkedIndicators = await getLinkedIndicators();

      setIndicatorsList(indicadores);

      // loadVerifyTask(listLinkedIndicators?.indicadores);

      const currentTime = await getServerTime();

      const date = new Date(currentTime);

      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      setMaxDate(format(lastDay, 'yyyy-MM-dd'));
      setMinDate(format(firstDay, 'yyyy-MM-dd'));

      const result = await findPlayer(user?._id, true);

      setTarget(result);
    }

    async function getInfoGestor() {
      const result = await getPlayerInfo('F' + userInfo?.ecoa_idgestor?.padStart(7, '0'));
      if (result) {
        setInitialManager(result);
      }
    }

    async function loadVerifyTask(indicadores?: LinkedIndicators_Indicadores[]) {
      const data = await verifyTask(params.id);

      if (data && data?.total && data?.total > 0 && indicadores?.length && indicadores?.length > 1) {
        setHasOtherType(true);
      }
    }

    if (user && userInfo) {
      if (params && params.id && params.id !== 'cadastrar') {
        // Só um `:id` novo relê a ação: com o mesmo `:id`, uma troca de `userInfo` sobrescreveria o que já foi editado.
        if (acaoEmLeitura.current !== params.id) {
          acaoEmLeitura.current = params.id;
          setCarregandoAcao(true);
          setFalhaAoCarregarAcao(false);
          setStep(primeiraEtapa());
          loadData();
        }
      } else {
        acaoEmLeitura.current = undefined;
        loadUserBySearch();
        getInfoGestor();
      }

      // loadNecs();
      // loadUors();
      // loadDemandates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, user, userInfo]);

  const periodStartIsValid: boolean = useMemo((): boolean => isPeriodStartValid(periodStart), [periodStart]);

  const periodEndIsValid: boolean = useMemo(
    (): boolean => isPeriodEndValid(periodStart, periodEnd, maxDate),
    [periodStart, periodEnd, maxDate],
  );

  const loadNec = async (necId: string) => {
    let necByLoad: any = await getNecs(necId);
    return necByLoad.length > 0 ? necByLoad[0] : null;
  };

  const defineSelectedNec = async (result: any) => {
    if (typeof result.nec === 'string') {
      const nec = await loadNec(result.nec);
      if (nec) {
        setDemandanteValue(nec.nm_uor_sltt);
        return {
          label: nec.cd_alcc + ' - ' + nec.nm_alcc,
          value: nec,
        };
      } else {
        return {
          label: '123456789 - SEM NEC VINCULADA',
          value: { cd_alcc: '123456789', nm_alcc: 'SEM NEC VINCULADA' },
        };
      }
    } else if (result.nec) {
      return {
        label: result.nec.cd_alcc + ' - ' + result.nec.nm_alcc,
        value: result.nec,
      };
    } else {
      return undefined;
    }
  };

  const dotsText = [
    'Até 20: Liberação automática;',
    'De 21 a 30: 3º nível gerencial de UE ou 2º nível de UT, UA ou CA;',
    'De 31 a 50: 2º nível gerencial de UE ou 1º nível de UT, UA ou CA;',
    'De 51 a 100: Diretor ou Gerente Geral UE;',
    'Acima de 100: Vice-Presidente.',
  ];

  function textRecomendation() {
    return (
      <div className="font-normal text-sm mt-4">
        {dotsText.map((text, index) => (
          <p key={text}>
            <span className="dots">&#8226;&nbsp;</span>
            {text}
          </p>
        ))}
      </div>
    );
  }

  let searchTimer: ReturnType<typeof setTimeout>;

  const timeoutDelay = 500;

  const handleInputChange = (e: any) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
    }

    searchTimer = setTimeout(() => {
      loadNecs(e);
    }, timeoutDelay);
  };
  const etapaInvalida = (etapa: number) => {
    return (
      (etapa === 0 && !target?.length) ||
      (etapa === 1 &&
        (!title?.length ||
          !periodStart?.length ||
          !periodEnd?.length ||
          !indicator?.label ||
          !indicator?.value ||
          !periodStartIsValid ||
          !periodEndIsValid ||
          !initialManager?._id ||
          new Date(periodEnd) < new Date(periodStart) ||
          !titleLength ||
          titleLength?.textLength < minTitleLength ||
          titleLength?.fullLength > maxTitleLength)) ||
      (etapa === 2 &&
        (!message ||
          !resultMessage ||
          !messageLength ||
          messageLength?.textLength < minMessageLength ||
          messageLength?.fullLength > maxMessageLength ||
          !resultLength ||
          resultLength?.textLength < minResultLength ||
          resultLength?.fullLength > maxResultLength))
    );
  };

  const buttonContinueIsDisabled = () => etapaInvalida(step);

  // Integrantes é a última etapa na tela: finalizar exige as três válidas.
  const finalizarDesabilitado = () => ORDEM_DE_EXIBICAO.some(etapaInvalida);

  const etapaParaVoltar = etapaAnterior(step);
  const etapaParaContinuar = proximaEtapa(step);

  function changeValue(id: string, value: number) {
    const input: any = document.getElementById(id);
    const newValue = value;
    input.value = newValue;

    validateInput(input);
  }

  // Toda troca de etapa leva o foco ao título dela (ECN-65), inclusive a volta para a primeira (o "Voltar" some ali).
  const etapaJaFocada = useRef(step);
  useEffect(() => {
    if (step !== etapaJaFocada.current) {
      toNextStepFocus();
    }
    etapaJaFocada.current = step;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const focarAoMontar = useCallback((elemento: HTMLElement | null) => elemento?.focus(), []);

  useEffect(() => {
    async function playerCanView() {
      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        toast.error(`Não há fase disponível para envio de realizações.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        return navigate('../');
      }
    }

    if (!!currentCycle && params && params.id && params.id === 'cadastrar') {
      playerCanView();
    }
  }, [currentCycle, navigate, params]);

  if (!userInfo) return null;

  const handleChangeNec = (selectedOption: any) => {
    setSelectedNec(selectedOption);

    if (selectedOption.value.cd_alcc === '123456789') {
      setShowDemandante(true);
      setDemandanteValue('');
    } else {
      setShowDemandante(false);
      setDemandanteValue(selectedOption.value.nm_uor_sltt);
    }
  };

  if (
    typeof params.id !== `string` ||
    typeof userInfo.ecoa !== `string` ||
    // userInfo.ecoa === 'INTEGRANTE' ||
    ((userInfo.ecoa === 'TUTOR' || userInfo.ecoa === 'COORDENADOR') && params.id === 'cadastrar') ||
    !!userInfo.visualizador
  ) {
    return null;
  }

  if (currentCycle?._id === '68af4da8458e527eaa788503') {
    return null;
  }

  function focusOnElement(selector: string) {
    const element: any = document.querySelector(selector);
    if (!!element) {
      element?.focus();
    }
  }

  // function afterOpenModal() {
  //   lastFocusedElementRef.current = document.activeElement as HTMLElement;
  //   const focusableElementsString =
  //     'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]';
  //   const focusableElements = modalRef.current?.querySelectorAll(focusableElementsString);
  //   const firstFocusableElement = focusableElements ? (focusableElements[0] as HTMLElement) : null;
  //   firstFocusableElement?.focus();

  //   document.addEventListener('keydown', trapFocus);
  // }

  // function trapFocus(event: KeyboardEvent) {
  //   const focusableElementsString =
  //     'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';
  //   const focusableElements = modalRef.current?.querySelectorAll(focusableElementsString);
  //   if (focusableElements) {
  //     const firstFocusableElement = focusableElements[0] as HTMLElement;
  //     const lastFocusableElement = focusableElements[focusableElements.length - 1] as HTMLElement;

  //     if (event.key === 'Tab') {
  //       if (event.shiftKey) {
  //         if (document.activeElement === firstFocusableElement) {
  //           lastFocusableElement.focus();
  //           event.preventDefault();
  //         }
  //       } else {
  //         if (document.activeElement === lastFocusableElement) {
  //           firstFocusableElement.focus();
  //           event.preventDefault();
  //         }
  //       }
  //     }
  //   }
  // }

  function toNextStepFocus() {
    focusOnElement('.informativeSteps h3');
  }

  if (user?.extra?.actions === false && userInfo?.ecoa !== 'TUTOR') return null;

  const podeIncluir = !target?.length || !teamApproval().blockAdd;

  const fecharAntesDoEnvio = () => {
    if (searchResults.length > 0) {
      reset();
    } else {
      setIsOpen(false);
    }
  };

  const desfecho: DesfechoDoCadastro | undefined = !submitted
    ? undefined
    : submitError
      ? { tipo: 'erro', titulo: 'Não deu pra enviar essa Ação Ecoa!', mensagem: submitError }
      : {
          tipo: 'sucesso',
          mensagem: `Sua Ação Ecoa foi ${editando ? 'atualizada' : 'cadastrada'}. Agora você poderá acompanhar o processo de validação da entrega que será realizado pelo tutor.`,
          rotuloDoAcompanhar: 'Acompanhar ação',
          onAcompanhar: () => setIsOpen(false),
        };

  return (
    <ModalDeCadastro
      key={'modal-create-task'}
      isOpen={isOpen}
      titulo={`${editando ? 'Editar' : 'Cadastrar'} Ação Ecoa`}
      etapas={ETAPAS_NA_TELA}
      etapaAtual={posicaoNaTela(step)}
      tituloDaEtapa={TITULOS_DAS_ETAPAS[step]}
      lembrete="Não há limite de integrantes: insira apenas colegas que efetivamente participaram da entrega."
      onFechar={submitted ? () => setIsOpen(false) : fecharAntesDoEnvio}
      onRequestClose={() => setIsOpen(false)}
      onAfterClose={handleCloseModal}
      classeDoFormulario="informativeSteps"
      desfecho={desfecho}
      rodape={
        !loading &&
        !carregandoAcao &&
        !falhaAoCarregarAcao && (
          <div className="ml-auto flex gap-2.5">
            {etapaParaVoltar !== undefined && (
              <Button
                variant="secundario"
                aria-label={`Voltar para a etapa ${posicaoNaTela(etapaParaVoltar) + 1} de cadastramento de ação ecoa`}
                onClick={() => setStep(etapaParaVoltar)}
              >
                Voltar
              </Button>
            )}
            {etapaParaContinuar !== undefined && (
              <Button
                variant="solido-destaque"
                onClick={() => (!buttonContinueIsDisabled() ? setStep(etapaParaContinuar) : null)}
                disabled={buttonContinueIsDisabled()}
                aria-label={`Continuar para a etapa ${posicaoNaTela(etapaParaContinuar) + 1}.`}
              >
                Continuar
              </Button>
            )}
            {step === ultimaEtapa() && (
              <Button
                variant="solido-destaque"
                disabled={finalizarDesabilitado()}
                onClick={() => handleSubmit()}
                aria-label={`${editando ? 'Atualizar' : 'Finalizar'} cadastramento de ação ecoa`}
              >
                {editando ? 'Atualizar' : 'Finalizar'}
              </Button>
            )}
          </div>
        )
      }
    >
      {loading && !submitted && (
        // O rodapé com o botão focado sai durante o envio: o foco vem para o aviso (WCAG 2.4.3).
        <p
          ref={focarAoMontar}
          role="status"
          tabIndex={-1}
          className="m-0 animate-pulse py-12 text-center font-display text-lg font-bold text-brand-blue-dark outline-none"
        >
          Enviando Ação Ecoa...
        </p>
      )}

      {carregandoAcao && (
        <p role="status" className="m-0 animate-pulse py-12 text-center font-display text-lg font-bold text-brand-blue-dark">
          Carregando Ação Ecoa...
        </p>
      )}

      {falhaAoCarregarAcao && (
        <p role="status" className="m-0 py-12 text-center font-display text-lg font-bold text-brand-blue-dark">
          Não foi possível carregar a Ação Ecoa. Feche e tente novamente.
        </p>
      )}

      {!loading && !carregandoAcao && !falhaAoCarregarAcao && !submitted && (
        <div className="flex flex-col gap-4">
          {step === 0 && (
            <>
              <div>
                <p id="cadastro-busca-instrucao" className={ROTULO}>
                  Inclua os membros da Ecoa que efetivamente atuaram com você nesta ação
                </p>
                {podeIncluir && (
                  <form onSubmit={handleSearch} role="search" className="relative">
                    <InputMask
                      type="search"
                      placeholder="Digite o nome ou chave do funcionário"
                      alwaysShowMask={false}
                      mask={mask}
                      ref={(ref: any) => {
                        searchRef.current = ref;
                      }}
                      onChange={e => {
                        handleChange();
                        buscaDeParticipantes.digitar(semMascara(searchRef.current?.value ?? e.target.value));
                      }}
                      inputMode="search"
                      aria-label="Buscar funcionário pelo nome ou chave"
                      aria-describedby="cadastro-busca-instrucao"
                      className={`${CAMPO} ${FOCO_VISIVEL} pr-11`}
                    />
                    <button
                      type="button"
                      aria-label="Buscar funcionário"
                      onClick={() => handleSearch()}
                      className={`absolute right-1.5 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-brand-blue ${FOCO_VISIVEL}`}
                    >
                      <TbSearch size={18} aria-hidden="true" />
                    </button>
                  </form>
                )}
              </div>

              {!buscandoParticipantes && isAlreadySelectedInList && (
                <AvisoDeValidacao>Esse usuário já foi inserido na lista de participantes.</AvisoDeValidacao>
              )}

              {/* Sempre montada: a busca ao digitar troca a lista sem tirar o foco do campo (AJ3-33). */}
              <p role="status" className="sr-only">
                {anuncioDosResultados(buscandoParticipantes, searchResults)}
              </p>

              {!!searchResults && searchResults.length > 0 && (
                <ul className="m-0 flex max-h-[30vh] list-none flex-col gap-2 overflow-y-auto p-0 lg:max-h-48">
                  {searchResults.map(item => (
                    <li key={item._id}>
                      <button
                        type="button"
                        onClick={() => addTarget(item)}
                        className={`flex w-full items-center gap-3 rounded-jj-md border border-surface-300 bg-brand-white px-3 py-2.5 text-left hover:border-brand-blue ${FOCO_VISIVEL}`}
                      >
                        <RostoDaPessoa pessoa={item} />
                        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                          <span className="text-[12.5px] font-bold text-content">
                            {item.extra?.nome_guerra} <span className="font-normal text-content-soft">({item._id})</span>
                          </span>
                          <span className="text-jj-label text-content-soft">{item.name}</span>
                          {!!item.extra?.diretoria || !!item.extra?.funcao ? (
                            <span className="text-jj-label text-content-soft">
                              {!!item.extra?.diretoria && <span className="text-brand-blue">{item.extra?.diretoria}</span>}
                              {!!item.extra?.diretoria && !!item.extra?.funcao && ' · '}
                              {item.extra?.funcao ? `${item.extra?.funcao}` : ''}
                            </span>
                          ) : null}
                        </span>
                        <FiPlus aria-hidden="true" size={19} className="shrink-0 text-brand-blue" />
                      </button>
                    </li>
                  ))}
                </ul>
              )}

              {!buscandoParticipantes && isEmptyName && (
                <AvisoDeValidacao>O funcionário que procura não é membro ECOA.</AvisoDeValidacao>
              )}

              {buscandoParticipantes && (
                <p role="status" className="m-0 animate-pulse text-xs font-bold text-brand-blue-dark">
                  Recuperando informações...
                </p>
              )}

              {target && target?.length > 0 && !buscandoParticipantes && (
                <div className="rounded-jj-lg bg-surface-100 px-4 py-3.5">
                  <div className="mb-3 flex flex-wrap items-center justify-between gap-2.5">
                    <p className="m-0 text-xs font-bold text-content">Total de participantes: {target?.length}</p>
                    <p className="m-0 text-jj-micro text-content">Sem limite de integrantes</p>
                  </div>
                  <ul aria-label="Integrantes selecionados" className="m-0 flex list-none flex-wrap gap-2 p-0">
                    {target.map((item: User, index: number) => {
                      const souEu = user?._id === item._id;
                      const nome = item.extra?.nome_guerra || item.name;

                      return (
                        <li
                          key={item._id}
                          className={`inline-flex items-center gap-2 rounded-jj-pill py-1 pl-1 text-[11.5px] ${
                            souEu
                              ? 'bg-brand-blue pr-3 text-brand-white'
                              : 'border border-surface-200 bg-brand-white pr-1.5 text-content'
                          }`}
                        >
                          <RostoDaPessoa pessoa={item} pequeno />
                          <span>
                            <b>{nome}</b> ({item._id})
                            {souEu && ' · você'}
                          </span>
                          {!souEu && item?._id !== currentTask?.owner && (
                            <button
                              type="button"
                              aria-label={`Remover ${nome} da ação`}
                              onClick={() => removeTarget(index)}
                              className={`flex h-5 w-5 items-center justify-center rounded-full bg-surface-200 text-content ${FOCO_VISIVEL}`}
                            >
                              <FiX aria-hidden="true" size={11} strokeWidth={3} />
                            </button>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              {!target?.length && !buscandoParticipantes && (
                <AvisoDeValidacao>Inclua ao menos 1 participante para finalizar.</AvisoDeValidacao>
              )}
            </>
          )}

          {step === 1 && (
            <>
              <div ref={ref => (titleRef.current = ref)}>
                <p className={ROTULO} aria-hidden="true">
                  Nome da ação
                </p>
                <TextEditor
                  disableEmoji
                  appearance="light"
                  ariaLabel="Nome da ação"
                  placeholder="Dê um nome curto e claro para a ação da sua Ecoa"
                  initialValue={title}
                  maxLength={maxTitleLength}
                  minLength={minTitleLength}
                  onChange={handleChangeTitle}
                  className="w-full text-[13px] text-content"
                />
              </div>

              <SelectField
                label="Eixos Temáticos"
                value={indicator}
                placeholder="Selecione o eixos temáticos ligado a Ação Ecoa"
                options={
                  indicatorsList
                    ? indicatorsList.map(item => ({ label: item.nome, value: item.cod }))
                    : [{ label: 'Carregando...', value: '' }]
                }
                onChange={(e: any) => [setIndicator(e)]}
              />

              <div className="flex flex-col gap-4 sm:flex-row">
                <div className="flex-1">
                  <label htmlFor="cadastro-ecoa-inicio" className={ROTULO}>
                    Início da ação
                  </label>
                  <input
                    id="cadastro-ecoa-inicio"
                    type="date"
                    defaultValue={periodStart}
                    min={PERIOD_START_MIN}
                    max={maxDate}
                    ref={ref => (periodStartRef.current = ref)}
                    onChange={e => setPeriodStart(format(utcToZonedTime(e.target.value, 'GMT'), 'yyyy-MM-dd'))}
                    className={`${CAMPO} ${FOCO_VISIVEL}`}
                  />
                </div>
                <div className="flex-1">
                  <label htmlFor="cadastro-ecoa-conclusao" className={ROTULO}>
                    Conclusão da ação
                  </label>
                  <input
                    id="cadastro-ecoa-conclusao"
                    type="date"
                    defaultValue={periodEnd}
                    min={PERIOD_END_MIN}
                    max={maxDate}
                    ref={ref => (periodEndRef.current = ref)}
                    onChange={e => setPeriodEnd(format(utcToZonedTime(e.target.value, 'GMT'), 'yyyy-MM-dd'))}
                    className={`${CAMPO} ${FOCO_VISIVEL}`}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="cadastro-ecoa-responsavel" className={ROTULO}>
                  Responsável por apreciar a ação
                </label>
                <div className="flex items-center gap-2">
                  <form onSubmit={handleSearchManager} className="flex-1">
                    <input
                      id="cadastro-ecoa-responsavel"
                      aria-describedby="cadastro-ecoa-responsavel-orientacao"
                      value={
                        !!initialManager && !!initialManager.nome_guerra
                          ? `${initialManager.nome_guerra} (${initialManager.chave}) - ${initialManager.funcao}`
                          : buscaDeResponsavel.texto
                      }
                      disabled={!!initialManager}
                      onChange={e => buscaDeResponsavel.digitar(e.target.value)}
                      placeholder={!initialManager ? 'Digite o nome ou chave do tutor ou coordenador' : undefined}
                      className={`${CAMPO} ${FOCO_VISIVEL}`}
                    />
                  </form>
                  {!!initialManager ? (
                    <button
                      type="button"
                      onClick={() => setInitialManager(null)}
                      aria-label="Alterar responsável por apreciação."
                      className={BOTAO_DO_RESPONSAVEL}
                    >
                      <FiEdit2 aria-hidden="true" size={17} />
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => handleSearchManager()}
                      aria-label="Buscar responsável por apreciação."
                      className={BOTAO_DO_RESPONSAVEL}
                    >
                      <RiSearchLine aria-hidden="true" size={17} />
                    </button>
                  )}
                </div>

                <p id="cadastro-ecoa-responsavel-orientacao" className="m-0 mt-2 text-xs leading-normal text-brand-blue">
                  Essa pessoa é responsável por realizar a apreciação desta entrega? Caso não seja ela, você pode alterá-la
                  clicando no ícone ao lado do campo.
                </p>

                {buscandoResponsavel && (
                  <p role="status" className="m-0 mt-2 animate-pulse text-xs font-bold text-brand-blue-dark">
                    Recuperando informações...
                  </p>
                )}

                <p role="status" className="sr-only">
                  {anuncioDosResultados(buscandoResponsavel, searchResultsManager)}
                </p>

                {!!searchResultsManager && searchResultsManager.length > 0 && (
                  <div className="mt-3">
                    <p className={ROTULO}>Resultado da pesquisa:</p>
                    <ul className="m-0 flex max-h-[30vh] list-none flex-col gap-2 overflow-y-auto p-0 lg:max-h-48">
                      {searchResultsManager.map(item => (
                        <li key={item._id}>
                          <button
                            type="button"
                            onClick={() => {
                              setInitialManager(item);
                              setSearchResultsManager([]);
                              buscaDeResponsavel.limpar();
                            }}
                            className={`flex w-full items-center gap-3 rounded-jj-md border border-surface-300 bg-brand-white px-3 py-2.5 text-left hover:border-brand-blue ${FOCO_VISIVEL}`}
                          >
                            <Iniciais nome={item.nome_guerra || item.nome} />
                            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                              <span className="text-[12.5px] font-bold text-content">{item.nome_guerra}</span>
                              <span className="text-jj-label text-content-soft">
                                {item.nome} ({item.chave})
                              </span>
                              {!!item?.diretoria || !!item?.funcao ? (
                                <span className="text-jj-label text-content-soft">
                                  {!!item?.diretoria && <span className="text-brand-blue">{item?.diretoria}</span>}
                                  {!!item?.diretoria && !!item?.funcao && ' · '}
                                  {item?.funcao ? `${item?.funcao}` : ''}
                                </span>
                              ) : null}
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                    <p className="m-0 mt-2 text-xs text-content-soft">
                      Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                    </p>
                  </div>
                )}
              </div>

              {!!title && !indicator?.value ? (
                <AvisoDeValidacao>Você precisa selecionar um eixo temático para continuar.</AvisoDeValidacao>
              ) : null}

              {!!periodStart?.length && !periodStartIsValid ? (
                <AvisoDeValidacao>A data de início da ação deve ser a partir de 01/01/2025. Altere para prosseguir.</AvisoDeValidacao>
              ) : null}

              {!!periodEnd?.length && !periodEndIsValid ? (
                <AvisoDeValidacao>
                  A data da entrega deve estar entre 01/07/2024 e último dia deste mês. Altere para prosseguir.
                </AvisoDeValidacao>
              ) : null}

              {(titleLength?.fullLength ?? 0) > maxTitleLength && (
                <AvisoDeValidacao>O Nome da ação inserido ultrapassou o limite máximo de {maxTitleLength} caracteres.</AvisoDeValidacao>
              )}
            </>
          )}

          {step === 2 && (
            <>
              <div ref={ref => (messageRef.current = ref)}>
                <p className={ROTULO} aria-hidden="true">
                  Detalhes da Ação Ecoa
                </p>
                <div className="h-40 w-full">
                  <TextEditor
                    disableEmoji
                    appearance="light"
                    ariaLabel="Detalhes da Ação Ecoa"
                    placeholder="Descreva o que a Ecoa realizou e como a ação aconteceu"
                    initialValue={message}
                    maxLength={maxMessageLength}
                    minLength={minMessageLength}
                    onChange={handleChangeMessage}
                  ></TextEditor>
                </div>
              </div>

              <div>
                <p className={ROTULO} aria-hidden="true">
                  Resultados da Ação Ecoa
                </p>
                <div className="h-40 w-full">
                  <TextEditor
                    disableEmoji
                    appearance="light"
                    ariaLabel="Resultados da Ação Ecoa"
                    placeholder="Aponte os resultados e benefícios alcançados"
                    initialValue={resultMessage}
                    maxLength={maxResultLength}
                    minLength={minResultLength}
                    onChange={handleChangeResult}
                  ></TextEditor>
                </div>
              </div>

              <p className="m-0 text-xs leading-normal text-brand-blue">
                Na descrição, não se esqueça de demonstrar clareza e objetividade dos resultados e benefícios alcançados por
                meio da sua ação ecoa.
              </p>

              <Nota>
                <p className="m-0">
                  Atente-se quanto à classificação do sigilo das informações (IN 421), considerando que o conteúdo ficará
                  visível a todos os participantes.
                </p>
              </Nota>

              {(messageLength?.fullLength ?? 0) > maxMessageLength && (
                <AvisoDeValidacao>
                  O Detalhes da Ação Ecoa inserido ultrapassou o limite máximo de {maxMessageLength} caracteres.
                </AvisoDeValidacao>
              )}
              {(resultLength?.fullLength ?? 0) > maxResultLength && (
                <AvisoDeValidacao>
                  O Detalhes da Ação Ecoa inserido ultrapassou o limite máximo de {maxResultLength} caracteres.
                </AvisoDeValidacao>
              )}
            </>
          )}
        </div>
      )}

      <NoticeModal
        isOpen={!!showModalAlert}
        title="Ops!"
        actionLabel="Entendi"
        onAction={() => setShowModalAlert(false)}
        onClose={() => setShowModalAlert(false)}
        closeLabel="Fechar aviso"
      >
        <p className="m-0">{showModalAlert}</p>
      </NoticeModal>
      {showModalTutorial && (
        <Modal
          onClose={() => {
            setshowModalTutorial(false);
          }}
          description={''}
        />
      )}
    </ModalDeCadastro>
  );
}
